import { MicroMClient } from "@mcurros2/microm";


export async function getMenusAndRedirectToHome(client: MicroMClient, no_redirect?: boolean) {
    const menus: Set<string> = await client.getMenus();
    const hasBackoffice = menus ? [...menus].some((menu) => menu.startsWith("BackofficeMenu_")) : false;
    const hasClientsHome = menus ? [...menus].some((menu) => menu.startsWith("ClientesHomeMenu_")) : false;

    if (!no_redirect) {
        if (hasBackoffice) {
            if (window.location.pathname !== '/') {
                window.location.href = '/';
            }
        }
        else if (hasClientsHome) {
            if (!window.location.pathname.startsWith('/clienteshome')) {
                window.location.href = '/clienteshome';
            }
        }
    }

}

